import { gsap } from 'gsap';
import throttle from 'just-throttle';

export function initInterfaceStates({
  startingThreshold = 30,
  showEventName = 'show-interface',
  initialClassName = 'is-interface-initial',
  hiddenClassName = 'is-interface-hidden',
  shownClassName = 'is-interface-shown',
  isScrollingDownClassName = 'is-scrolling-down',
  isScrollingUpClassName = 'is-scrolling-up',
  isResizingClass = 'is-resizing',
  isResizingTimeout = 100,
  parentElement = document.body,
} = {}) {
  let prevPosition = window.scrollY;

  parentElement.classList.add(initialClassName);

  const topbar = document.querySelector('.topbar__inner, .topbar-mini__inner');
  const fadeOutTween = gsap.fromTo(
    topbar,
    { opacity: 1, yPercent: 0 },
    {
      opacity: 0,
      yPercent: -5,
      duration: 0.3,
      ease: 'power3.out',
      paused: true,
      immediateRender: false,
    },
  );

  const hide = async () => {
    parentElement.classList.add(hiddenClassName);
    parentElement.classList.remove(initialClassName);
    parentElement.classList.remove(shownClassName);

    fadeOutTween.play();
  };
  const show = () => {
    parentElement.classList.add(shownClassName);
    parentElement.classList.remove(hiddenClassName);

    fadeOutTween.reverse();
  };

  const handleScrolling = () => {
    const position = window.scrollY;
    const isScrollingDown = position > prevPosition;
    prevPosition = position;

    if (isScrollingDown) {
      parentElement.classList.add(isScrollingDownClassName);
      parentElement.classList.remove(isScrollingUpClassName);
    } else {
      parentElement.classList.add(isScrollingUpClassName);
      parentElement.classList.remove(isScrollingDownClassName);
    }

    if (position < startingThreshold) {
      show();
      return;
    }

    if (isScrollingDown) {
      hide();
    } else {
      show();
    }
  };

  window.addEventListener('scroll', throttle(handleScrolling, 100));
  window.addEventListener(showEventName, show);

  let timer;
  window.addEventListener('resize', () => {
    parentElement.classList.add(isResizingClass);

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      parentElement.classList.remove(isResizingClass);
      timer = null;
    }, isResizingTimeout);
  });
}
